import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import { ACTION_BACK_PATH, CHILDREN_IMMUNISATION_NOTIFICATIONS_PATH } from '@shared/constants/paths';
import type { RouteConfig } from '@shared/types/common.types';

const ChildrenImmunisationNotificationsListPage = lazy(
  () => import('./pages/ChildrenImmunisationNotificationsListPage/ChildrenImmunisationNotificationsListPage')
);

export const CHILDREN_IMMUNISATION_NOTIFICATION_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.MOBILE, LayoutType.PORTAL],
    component: () => <ChildrenImmunisationNotificationsListPage />,
    displayTitle: () => "Children's Immunisation Updates",
    pageType: PageType.PRIVATE,
    path: CHILDREN_IMMUNISATION_NOTIFICATIONS_PATH,
    serviceCatalogCode: '',
  },
];
